import Toggle, {Size} from '@jetbrains/ring-ui/components/toggle/toggle'
import isEqual from 'lodash/isEqual'
import React, {memo} from 'react'

import SettingsBlock from '../../../../SettingsBlock/SettingsBlock'

import JobTriggerForm from './JobTriggerForm/JobTriggerForm'
import PipelineTrigger from './PipelineTrigger/PipelineTrigger'
import {getDaysOfWeekLabel, getTimeLabel} from './PipelineTrigger/PipelineTrigger.utils'
import {TriggerType} from './PipelineTriggers.consts'
import usePipelineTriggers from './PipelineTriggers.hooks'

import styles from './PipelineTriggers.css'

function PipelineTriggers() {
  const {
    triggers,
    sevedTriggers,
    isShowTriggerForm,
    handlerDisabledToggleChange,
    handlerAddJobTriggerButtonClick,
    handlerJobTriggerFormApply,
    handlerJobTriggerFormClose,
    handlerJobTriggerEditApply,
    handlerTriggerDelete,
  } = usePipelineTriggers()

  return (
    <SettingsBlock
      id="triggers"
      collapsible
      title="Auto-Run Pipeline"
      collapsedDefault
      collapsedNote={triggers
        ?.filter(({disabled}) => !disabled)
        .map(({type, parameters = {}}) =>
          type === TriggerType.VCS
            ? 'On new changes'
            : `every ${getDaysOfWeekLabel(parameters.daysOfWeek)} at ${getTimeLabel(parameters)}`,
        )
        .join(', ')}
      onAddClick={handlerAddJobTriggerButtonClick}
    >
      {triggers?.map((trigger, index) => {
        const {disabled, type, parameters} = trigger
        const sevedTrigger = sevedTriggers[index]
        const isVcsTrigger = type === TriggerType.VCS
        const key = `${index}_${type}`
        const isUnsaved = !isEqual(trigger, sevedTrigger)

        if (isVcsTrigger) {
          return (
            <div key={key} className={styles.triggerNewChangesToggleWrapper}>
              <Toggle
                title="On new changes"
                className={styles.triggerNewChangesToggle}
                onChange={handlerDisabledToggleChange(index)}
                size={Size.Size16}
                checked={!disabled}
              >
                {'On new changes'}
              </Toggle>
            </div>
          )
        }

        return (
          <PipelineTrigger
            onDisabled={handlerDisabledToggleChange(index)}
            onDelete={handlerTriggerDelete(index)}
            key={key}
            onApply={handlerJobTriggerEditApply(index)}
            parameters={parameters}
            disabled={!disabled}
            unsaved={isUnsaved}
          />
        )
      })}
      {isShowTriggerForm && (
        <JobTriggerForm
          onApply={handlerJobTriggerFormApply}
          onCancel={handlerJobTriggerFormClose}
        />
      )}
    </SettingsBlock>
  )
}

export default memo(PipelineTriggers)
